import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks
 * @param {string} dirty - Unsanitized HTML string
 * @param {object} options - DOMPurify configuration options
 * @returns {string} - Sanitized HTML string
 */
export const sanitizeHTML = (dirty, options = {}) => {
  const defaultConfig = {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li', 'span', 'div'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
    ALLOW_DATA_ATTR: false,
  };

  const config = { ...defaultConfig, ...options };
  return DOMPurify.sanitize(dirty, config);
};

/**
 * Create sanitized HTML props for React dangerouslySetInnerHTML
 * @param {string} html - Unsanitized HTML string
 * @param {object} options - DOMPurify configuration options
 * @returns {object} - Object with __html property containing sanitized HTML
 */
export const createSafeHTML = (html, options = {}) => {
  return { __html: sanitizeHTML(html, options) };
};
